import styled from 'styled-components';

const IconReturnStyled = styled.svg`
  fill: ${props => props.theme.icons.arrow.route};
  padding: 0;
  position: relative;
`;

export default IconReturnStyled;
